

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { DireccionGeograficaIDE } from '../entity-direcciones-geografica-ide/direcciones-geografica-ide.model';

export interface EntityDireccionesGeograficaIDEExactaState {
  direccionGeograficaIDEExacta: DireccionGeograficaIDE[];
  mapa: string;  
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityDireccionesGeograficaIDEExactaState =
  {
    direccionGeograficaIDEExacta: null,
    mapa: null,
    isLoading: false,
    error: null
  };

